import { RouterService } from './../router.service';
import {
  Component,
  OnInit,
  ViewChild,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { DonateData, SendDonateData } from '../donate-data';
import { AppComponent } from '../app.component';
import { ActivatedRoute } from '@angular/router';
import { SendMessageService } from '../send-message.service';
import { ControlData, ControlNext } from '../controll-screen/control-data';
import { DonateChangeService } from '../donate-change.service';
import { ControlJumpData } from './control-jump-data';
import { SettingService, YoutubeRestrictionData } from '../setting.service';
import { SettingData } from '../setting-data';
import { CheckUidService } from '../check-uid.service';
import { CookieService } from 'ngx-cookie-service';
import { MatTable } from '@angular/material/table';
import { CheckIdService } from '../check-id.service';
import { YoutubeApiService } from '../youtube-api.service';
import { GuidService } from '../guid.service';
import { Paho } from 'ng2-mqtt/mqttws31';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { FunctionService } from '../function.service';
import * as $ from "jquery";
@Component({
  selector: 'app-controll-screen',
  templateUrl: './controll-screen.component.html',
  styleUrls: ['./controll-screen.component.scss'],
})
export class ControllScreenComponent implements OnInit, OnDestroy {
  @ViewChild('table') table: MatTable<Element>;
  donateState: number; // 0: waiting, 1: patron, 2: donate, 3: play  vedio
  player: YT.Player;
  ytEvent: any;
  playerVars = {
    cc_lang_pref: 'en',
  };
  yid = '';
  testYid = '';
  id: string;
  currentDonate: DonateData;
  donateList: Array<DonateData>;
  videoTimeLeft = 0;
  videoInterval: any;
  patronTimeLeft = 0;
  patronInterval: any;
  donateTimeLeft = 0;
  donateInterval: any;
  settingData: SettingData;
  checkState: number;
  play: boolean;
  volume: number;
  voiceVolume: number;
  displayedColumns: string[] = ['name', 'donate', 'time', 'msg'];
  pos = -1;
  isLoop: boolean;
  testName = '';
  testDonate = 0;
  testMsg = '';
  testEndtime = 0;
  testYt = '';
  testStime = 0;
  checkIDState = 0;
  youtubeRestrictionData: YoutubeRestrictionData;
  paginatorLength = 1;
  paginatorPageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  videoPlayTime: 0;
  checkVideoPlayInterval: any;
  isSecondPatronTurn = false;
  // tslint:disable-next-line: deprecation
  constructor(
    private appComponent: AppComponent,
    private activatedRouter: ActivatedRoute,
    public routerService: RouterService,
    private sendMessage: SendMessageService,
    private donateChange: DonateChangeService,
    private settingService: SettingService,
    private checkUidService: CheckUidService,
    private cookieService: CookieService,
    private checkIDService: CheckIdService,
    private youtubeAPI: YoutubeApiService,
    private scrollDispatcher: ScrollDispatcher,
    private functionService: FunctionService
  ) {
    this.donateState = 0;
    this.isLoop = false;
    this.donateChange.donateDataChange.subscribe((value) => {
      if (value) {
        this.isSecondPatronTurn = false;
        this.currentDonate = value;
        this.onDonateStateChange(1);
        this.yid = this.functionService.parserYTID(this.currentDonate.yt);
        if (this.yid !== '') {
          this.videoTimeLeft = this.currentDonate.time;
          this.pauseVideoTimer();
        }
        if (this.checkVideoPlayInterval) {
          clearInterval(this.checkVideoPlayInterval);
        }
        this.videoPlayTime = 0;
      }
    });
    this.donateChange.timeChange.subscribe((value) => {
      this.videoTimeLeft = value;
      if (this.videoTimeLeft === 0) {
        this.yid = this.functionService.parserYTID('');
        this.pausePatronTimer();
        this.pauseVideoTimer();
        this.pauseDonateTimer();
        this.onDonateStateChange(0);
      }
    });
    this.settingService.settingDataChange.subscribe((settingData) => {
      this.settingData = settingData;
      if (this.settingData.isloop || this.cookieService.get('isLoop')) {
        this.cookieService.set('isLoop', '1', 999999, '/');
        this.isLoop = true;
      }
      this.volume = settingData.volume;
      this.voiceVolume = settingData.voiceVolume * 100;
      this.onVolumeChange(this.volume);
      this.onVoiceVolumeChange(this.voiceVolume);
    });
    this.donateChange.donateDataListChange.subscribe((value) => {
      this.paginatorLength = (value.length % this.paginatorPageSize) + 1;
      this.donateList = value;
      if (this.pos === -1) {
        this.pos = this.donateList.length;
      }
      this.donateList = this.donateList.slice().reverse();
    });
    this.checkIDService.checkStateChange.subscribe((value) => {
      if (value === 1) {
        this.checkIDState = 1;
      } else {
        alert('此ID不存在');
        this.routerService.GoToHomePage();
      }
    });
  }

  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    await this.cookieService.delete('control', '/');
  }

  ngOnInit(): void {
    this.cookieService.set('control', '1', 999999, '/');
    this.id = this.activatedRouter.snapshot.paramMap.get('id');
    this.appComponent.client.subscribe('check_id/' + this.id + '/res');
    this.appComponent.client.subscribe('setting/' + this.id + '/res');
    this.voiceVolume = 100;
    this.volume = 50;
    if (this.checkID()) {
      const client = new Paho.MQTT.Client(
        this.appComponent.mqttbroker,
        Number(8084),
        GuidService.newGuid()
      );
      const will = new Paho.MQTT.Message(JSON.stringify({ msg: 'closed' }));
      will.destinationName = 'window_check/' + this.id + '/res';
      will.qos = 0;
      client.connect({
        onSuccess: this.appComponent.onConnect.bind(this),
        useSSL: true,
        willMessage: will,
      });
      this.getList();
      this.checkState = 1;
      this.appComponent.client.subscribe('control/' + this.id + '/res');
      this.appComponent.client.subscribe('donate/' + this.id + '/res');
      this.currentDonate = this.appComponent.currentDonateData;
      this.appComponent.client.subscribe('account/' + this.id + '/res');
      this.appComponent.client.subscribe('control_msg/' + this.id + '/res');
      this.appComponent.client.subscribe('control_song/' + this.id + '/res');
      this.appComponent.client.subscribe('window_check/' + this.id + '/send');
      const loginData = new ControlData(this.id, 'login');
      const message = JSON.stringify(loginData);
      this.sendMessage.sendMessage(
        this.appComponent.client,
        message,
        'account/' + this.id + '/send'
      );
      this.sendMessage.sendMessage(
        this.appComponent.client,
        JSON.stringify({ msg: 'opened' }),
        'window_check/' + this.id + '/res'
      );
      this.next();
    } else {
      this.goToLogin();
    }
    this.sendMessage.sendMessage(
      this.appComponent.client,
      JSON.stringify({ id: this.id }),
      'check_id/send'
    );
    this.scrollDispatcher.scrolled().subscribe(() => {
      if ($(window).scrollTop()) {
        $('nav').addClass('black');
      } else {
        $('nav').removeClass('black');
      }
    });
  }

  next(): void {
    this.pauseVideoTimer();
    let contorlData: ControlNext;
    if (this.donateList) {
      if (this.pos === 0) {
        contorlData = new ControlNext(
          this.id,
          'endnext'
        );
      } else if (this.currentDonate) {
        contorlData = new ControlNext(
          this.id,
          'next'
        );
      } else {
        contorlData = new ControlNext(this.id, 'endnext');
      }
    } else {
      contorlData = new ControlNext(this.id, 'endnext');
    }
    const message = JSON.stringify(contorlData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control_next/' + this.id + '/send'
    );
  }

  pausevideo(): void {
    this.play = false;
    this.player.pauseVideo();
    this.pauseVideoTimer();
    const obj = { id: this.id, action: 'pause' };
    const message = JSON.stringify(obj);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control/' + this.id + '/send'
    );
  }

  playvideo(): void {
    this.play = true;
    this.startVideoTimer(this.videoTimeLeft);
    this.player.playVideo();
    const obj = { id: this.id, action: 'play' };
    const message = JSON.stringify(obj);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control/' + this.id + '/send'
    );
  }

  find(i: number): void {
    this.pauseVideoTimer();
    const contorlJumpData: ControlJumpData = new ControlJumpData(
      this.id,
      this.donateList[i].name,
      this.donateList[i].donate,
      this.donateList[i].msg
    );
    const message = JSON.stringify(contorlJumpData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control_jump/' + this.id + '/send'
    );
  }

  previous(): void {
    this.pauseVideoTimer();
    const contorlData: ControlData = new ControlData(this.id, 'previous');
    const message = JSON.stringify(contorlData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control/' + this.id + '/send'
    );
  }

  playend(): void {
    this.videoTimeLeft = 999999;
    const contorlData: ControlData = new ControlData(this.id, 'playend');
    const message = JSON.stringify(contorlData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control/' + this.id + '/send'
    );
    this.cookieService.delete('isLoop', '/');
    this.isLoop = false;
  }

  getList(): void {
    const contorlData: ControlData = new ControlData(this.id, 'get');
    const message = JSON.stringify(contorlData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control/' + this.id + '/send'
    );
  }

  getdonate(): void {
    const contorlData: ControlData = new ControlData(this.id, 'get');
    const message = JSON.stringify(contorlData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'donate/' + this.id + '/send'
    );
  }

  savePlayer(player) {
    this.player = player;
    this.player.setSize(640, 360);
    this.player.loadVideoById(this.yid, this.currentDonate.stime);
    this.player.playVideo();
    this.player.mute();
    this.checkVideoStartTimer();
  }

  onDonateStateChange(donateState: number) {
    console.log('donate:: ' + donateState);
    this.donateState = donateState;
    if (this.donateState === 0) {
    }
    if (this.donateState === 1) {
      for (let index = 0; index < this.donateList.length; index++) {
        const element = this.donateList[index];
        if (
          element.donate === this.currentDonate.donate &&
          element.msg === this.currentDonate.msg &&
          element.name === this.currentDonate.name &&
          element.yt === this.currentDonate.yt
        ) {
          this.pos = index;
        }
      }
      if (this.table) {
        this.table.renderRows();
      }
      if (this.currentDonate.pic2 !== '') {
        this.startPatronTimer(3);
      } else {
        this.startPatronTimer(1);
      }
    }
    if (this.donateState === 2) {
      this.startDonateTimer(5);
    }
    if (this.donateState === 3) {
      if (this.player) {
        this.player.playVideo();
        this.play = true;
      }
      // this.startVideoTimer(this.currentDonate.stime);
    }
  }

  onStateChange(event) {
    console.log('youtube:: ' + event.data);
    if (!event.data) {
      console.log(this.currentDonate.time);
      if (this.cookieService.check('isLoop')) {
        this.player.playVideo();
      } else {
        console.log('here');
        this.onDonateStateChange(0);
        this.next();
      }
    }
    this.ytEvent = event.data;
    if (this.ytEvent === 1) {
      // 開始播
      this.startVideoTimer(this.videoTimeLeft);
    }
    if (this.ytEvent === 2) {
      // 按暫停
      this.pauseVideoTimer();
    }
    if (this.ytEvent === 0) {
      // 初始化成功
      // this.next();
    }
    if (this.ytEvent === 5) {
      // 播完了(stopVideo())
      this.player.destroy();
      this.onDonateStateChange(0);
      this.next();
    }
  }

  startVideoTimer(time: number) {
    this.pausePatronTimer();
    this.pauseVideoTimer();
    this.pauseDonateTimer();
    this.videoTimeLeft = time;
    this.videoInterval = setInterval(() => {
      this.videoPlayTime++;
      if (this.videoTimeLeft > 0) {
        this.videoTimeLeft--;
      } else {
        this.pauseVideoTimer();
        this.player.stopVideo();
        return;
      }
    }, 1000);
  }

  pauseVideoTimer() {
    clearInterval(this.videoInterval);
  }

  startPatronTimer(time: number) {
    this.pausePatronTimer();
    this.pauseVideoTimer();
    this.pauseDonateTimer();
    this.patronTimeLeft = time;
    this.patronInterval = setInterval(() => {
      if (time === 3 &&　this.patronTimeLeft === 2) {
        this.isSecondPatronTurn = true;
      }
      if (this.patronTimeLeft > 0) {
        this.patronTimeLeft--;
      } else {
        this.onDonateStateChange(2);
        this.pausePatronTimer();
      }
    }, 1000);
  }

  pausePatronTimer() {
    clearInterval(this.patronInterval);
  }

  startDonateTimer(time: number) {
    this.pausePatronTimer();
    this.pauseVideoTimer();
    this.pauseDonateTimer();
    this.donateTimeLeft = time;
    this.donateInterval = setInterval(() => {
      if (this.donateTimeLeft > 0) {
        this.donateTimeLeft--;
      } else {
        if (this.yid !== '') {
          this.onDonateStateChange(3);
          this.pauseDonateTimer();
        } else {
          this.onDonateStateChange(0);
          this.pauseDonateTimer();
          this.next();
        }
      }
    }, 1000);
  }

  pauseDonateTimer() {
    clearInterval(this.donateInterval);
  }

  checkVideoStartTimer() {
    this.checkVideoPlayInterval = setInterval(() => {
      if (this.videoPlayTime === 0) {
        this.next();
      }
      clearInterval(this.checkVideoPlayInterval);
    }, 5000);
  }

  checkID(): boolean {
    if (!this.cookieService.check('id')) {
      return false;
    }
    if (this.cookieService.get('id') === this.id) {
      return true;
    }
    return false;
  }

  goToLogin(): void {
    alert('Google帳號錯誤');
    this.routerService.GoToHomePage();
  }

  volumetext(value: number) {
    if (value >= 0) {
      return Math.round(value) + '%';
    }
    return value;
  }

  onVolumeChange(volume: number) {
    const obj = { id: this.id, action: 'changeVolume', msg: volume };
    const message = JSON.stringify(obj);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control_msg/' + this.id + '/send'
    );
  }

  onIsLoopChange() {
    if (this.isLoop) {
      this.cookieService.set('isLoop', '1', 999999, '/');
    } else {
      this.cookieService.delete('isLoop', '/');
    }
  }

  voiceVolumetext(value: number) {
    if (value >= 0) {
      return Math.round(value) + '%';
    }
    return value;
  }

  onVoiceVolumeChange(volume: number) {
    const obj = { id: this.id, action: 'changeVoiceVolume', msg: volume / 100 };
    const message = JSON.stringify(obj);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control_msg/' + this.id + '/send'
    );
  }

  sendTestDonate() {
    if (this.testDonate < this.settingData.min_money) {
      alert('金額必須大於' + this.settingData.min_money + '元');
      // } else if (this.testYt.length > 0) {
      //   this.youtubeAPI.getVideoStatistics(this.yid).subscribe((res) => {
      //     if (
      //       res.items.length > 0 &&
      //       res.items[0].statistics.viewCount >
      //         this.youtubeRestrictionData.viewCountRestriction &&
      //       res.items[0].statistics.likeCount /
      //         (res.items[0].statistics.likeCount +
      //           res.items[0].statistics.dislikeCount) >
      //         this.youtubeRestrictionData.goodRateRestriction
      //     ) {
      //       this.submit();
      //     } else {
      //       alert('此影片不符合規定');
      //       this.testYt = '';
      //       this.yid = '';
      //     }
      //   });
    } else {
      this.submit();
    }
  }

  onkeyupYT(event: any) {
    [this.testYt, this.testStime] = this.functionService.convertUrl(this.testYt);
    this.testYid = this.functionService.parserYTID(this.testYt);
  }
  endTime() {
    this.testEndtime =
      this.testStime +
      this.settingData.basetime +
      this.settingData.times * this.testDonate;
  }

  submit(): void {
    const testDonateData = new SendDonateData(
      this.id,
      this.testName,
      this.testDonate,
      this.testYt,
      this.testStime,
      0,
      this.testMsg,
    );
    const message = JSON.stringify(testDonateData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'donate/' + this.id + '/send'
    );
  }
}
